module.exports = __webpack_public_path__ + "static/img/A103.6d85a965.jpg";